import type { TourStep } from '../types';

export const convertingLeadsSteps: TourStep[] = [
  {
    target: '[data-tour="leads-table"]',
    title: 'From Lead to Assignment',
    content:
      'When a lead is ready to become a real job, you convert it right from this table. The lead\'s property and contact info carry over automatically — no re-entry.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="leads-actions"]',
    title: 'Convert Options',
    content:
      'Open the actions menu on any inquiry and choose Convert. You\'ll pick whether to create an Engagement Letter first or go straight to a new Appraisal.',
    placement: 'left',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I see the menu',
  },
  {
    target: '[data-tour="leads-filters"]',
    title: 'Track Your Pipeline',
    content:
      'Filter by "Converted" status to see which leads became assignments. This helps you track the full pipeline from inquiry to completed report.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: 'a[href="/appraisals"]',
    title: 'Find Your New Appraisal',
    content:
      'After converting, your new appraisal appears in the Appraisals section with the property address, client name, and other details pre-filled from the inquiry.',
    placement: 'right',
    spotlightClicks: true,
  },
];
